import styled from "styled-components"
import {down, up} from "styled-breakpoints";

export const Wrapper = styled.div`
    font-family: Archivo;
    padding-bottom: 80px;

    > .container {
        ${down("md")} {
            max-width: 100%;
        }
    }

    .header {
        font-weight: 600;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: 0.47px;
        text-transform: capitalize;

        .close-btn {
            display: none;
        }

        ${down("md")} {
            .close-btn {
                display: block;
            }

            font-family: Archivo;
            font-weight: 700;
            font-size: 18px;
            line-height: 100%;
            letter-spacing: 0px;
            text-transform: capitalize;
        }
    }

    ${down("md")} {
        .container .order-summary-col {
            display: none;
        }
    }

    .mobile-sticky-checkout {
        display: none;

        ${down("md")} {
            display: block;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background: white;
            padding: 12px 16px;
            box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
            z-index: 1000;
            border-top: 1px solid #e0e0e0;
        }
    }

    .sticky-checkout-btn {
        width: 100%;
        border-radius: 36px;
        padding: 12px;
        font-weight: 600;
        font-size: 1em;
        background: #0b9c07;
        border: 1px solid #0b9c07;
        color: white;

        &:disabled {
            background: #cccccc;
            border-color: #cccccc;
            color: #666666;
        }
    }
`
export const CartItemStyle = styled.div`
    font-family: Archivo;

    > div.first {
        display: flex;
        align-items: start;
        margin-right: 10px;

        label {
            width: 20px;
            height: 20px;
            margin-right: 4px;
            margin-top: 2px;

            input {
                position: absolute;
                inset: 0;
                opacity: 0;
                cursor: pointer;
            }
        }
    }

    > div:last-child {
        border: 1px solid #F2F2F2;
        width: 100%;
        padding: 10px;
        border-radius: 8px;

        > .card-img {
            width: 60px;
            height: 60px;
            overflow: hidden;
            border-radius: 8px;

            img {
                width: 100%;
                object-fit: cover;
            }
        }

        > .card-body {
            > .first {
                > .card-title {
                    --tw-text-opacity: 1;
                    color: var(--color-text-slight-dark);
                    font-size: 16px;
                    line-height: 100%;
                    font-weight: 500;
                }

                > .card-location {
                    font-size: 13px;
                    letter-spacing: 0;
                }

                > .card-delivery-date {
                    font-size: 11px;
                }

                > .card-text {
                    display: flex;
                    align-items: center;
                    line-height: 100%;
                    text-transform: capitalize;
                    color: #808080;

                    &:first-child {
                        font-weight: 400;
                    }

                    &:last-child {
                        font-weight: 300;
                    }

                }
            }

            > div:last-child {
                font-size: 15px;

                p {
                    leading-trim: none;
                    font-size: inherit;
                    line-height: 100%;
                    color: var(--color-primary);
                    text-transform: capitalize;

                    span {
                        font-family: Saira;
                        font-weight: 500;
                    }

                    small {
                        font-weight: 400;
                        font-size: 12px;
                        line-height: 100%;
                        letter-spacing: 0px;
                        text-transform: none;
                        position: relative;
                    }
                }

            }
        }

        > div div:last-child {
            margin-top: 1rem;
        }

        > .quantity {
            margin-left: auto;
            align-self: end;
            justify-content: right;
            text-align: right;

            > div:first-child {

                > .card-text {
                    font-weight: 400;
                    font-size: 12px;
                    color: #808080;

                    b {
                        font-weight: 600;
                    }
                }

                > .badge {
                    width: max-content;
                    padding: 0;
                    --bs-secondary-rgb: 255, 225, 186;
                    color: rgba(255, 165, 49);
                    padding-inline-end: var(--bs-badge-padding-x);

                    > .badge {
                        --bs-secondary-rgb: 255, 165, 49;
                        margin-inline-end: var(--bs-badge-padding-x);
                    }
                }

                .badge {
                    font-size: 9px;
                    font-weight: 500;
                }
            }
        }
    }

    ${down("md")} {
        > div.first {
            margin-right: 5px;
        }

        > div:last-child {
            > .card-body {
                > .first {
                    letter-spacing: 0.5px;

                    > .card-title {
                        font-size: 12px;
                        letter-spacing: inherit;
                    }

                    > .card-location {
                        font-size: 10px;
                        letter-spacing: inherit;
                    }

                    > .card-delivery-date {
                        font-size: 9px;
                        letter-spacing: inherit;
                    }
                }

                > div:last-child {
                    font-weight: 500;
                    font-size: 12px;
                    leading-trim: NONE;
                    line-height: 100%;
                    letter-spacing: 0px;

                    p small {
                        font-size: 8px;
                    }
                }

                > div div:last-child {
                    margin-top: .5rem;
                }

                > .quantity {
                    > div:first-child {
                        > .card-text {
                            font-size: 8px;
                        }

                        > .badge {
                            font-size: 7.8px;
                        }
                    }
                }
            }
        }
    }
`
export const CounterInputStyle = styled.div`
    position: relative;
    align-items: center;
    display: flex;
    justify-content: right;

    button, input {
        flex-shrink: 0;
    }

    button:disabled {
        background-color: lightgray;
    }

    input {
        background-color: transparent;
        max-width: 2.5rem;
        text-align: center;
        outline: none !important;
        color: var(--color-primary-dark);
        border-bottom: .89px solid #f6f5f5;
        font-weight: 600;
        padding: 1px 7.13px;
    }

    button {
        --bs-btn-bg: var(--color-primary-light);
        --bs-btn-hover-bg: var(--color-primary-light);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: none;
        border-radius: 5px;
        padding: 4px;
        width: initial !important;

        svg {
            width: .625rem;
            height: .625rem;
            color: var(--color-primary);
            margin-inline: initial !important;
        }
    }
`
export const OrderSummaryStyle = styled.div`
    .header {
        font-weight: 600;
        font-size: 18px;
        line-height: 100%;
        letter-spacing: 0.47px;
        text-transform: capitalize;

        ${down("md")} {
            font-size: 14px;
            font-weight: 500;
            line-height: 100%;
            letter-spacing: -0.03em;
            text-align: center;
        }
    }

    .modal-desc {
        text-align: center;
    }

    .sub-total {
        color: #666666;
        font-size: 14px;

        h4.title {
            font-weight: 400;
        }

        h6 {
            font-weight: 500;
        }
    }

    .total {
        color: black;

        h4.title {
            font-weight: 600;
            font-size: 14px;
        }

        h6 {
            font-weight: 600;
            font-size: 16px;
        }
    }

    .btn-secondary {
        background: #0b9c07;
    }

    .btn-outline-secondary {
        color: #0b9c07;
    }

    button {
        border-color: #0b9c07;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        border-radius: 36px;
        padding: 8.5px;
        font-weight: 600;
        font-size: 1em;
        --bs-btn-font-family: Archivo;

        svg {
            margin-left: 4px;
        }
    }
`